import { useState, useEffect } from 'react';
import { fetchData } from './helpers';

export const useQuery = (query, options) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [errors, setErrors] = useState(null);

  const fetchApi = async () => {
    setLoading(true);
    try {
      const body = {
        query,
        variables: options.variables || {}
      };
      const { data, errors } = await fetchData(body, options || {});
      if (errors) {
        setErrors(errors);
      } else {
        setErrors(null);
      }
      setData(data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setErrors(err);
    }
  };

  useEffect(() => {
    fetchApi();
  }, [JSON.stringify(options.variables)]);

  return { loading, data, errors, refetch: fetchApi };
};
